export default __webpack_public_path__ + "chevron-pointing-to-the-left.png";